import style from './Footer.module.css';

export const Footer = () =>
  <div className={style.Footer}>

  </div>